export enum ORIGIN_REGISTER {
	FACEBOOK = 1,
	GOOGLE = 2,
	NINGUNA = 3,
}

export enum TYPE_TOAST {
	SUCCESS = 1,
	WARNING,
	INFO,
	ERROR,
}
